module.exports = __webpack_public_path__ + "img/bg2.751b691e.png";